var map = {
	"./S/avatar.png": "235f",
	"./guskma/avatar.png": "64d3",
	"./guskma/header.png": "0019",
	"./guskma2/avatar.png": "6b32",
	"./guskma2/header.png": "d436",
	"./guskma3/avatar.png": "f696",
	"./guskma3/header.png": "a395",
	"./guskma4/avatar.png": "bba6",
	"./guskma4/header.png": "0167",
	"./guskma5/avatar.png": "baf3",
	"./guskma5/header.png": "1d09",
	"./localadms/avatar.gif": "695c",
	"./tomoki/avatar.png": "e5ee",
	"./toneji/avatar.jpg": "09dd",
	"./vaginaplant/avatar.jpg": "f868"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a0d";